import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { NativeBaseProvider } from 'native-base';
import React from 'react';
import theme from '../../theme';
const Client = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false
    }
  }
});
const config = {
  dependencies: {
    'linear-gradient': require('react-native-linear-gradient').default
  }
};
const ContextProvider = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(NativeBaseProvider, {
    theme: theme,
    config: config
  }, /*#__PURE__*/React.createElement(QueryClientProvider, {
    client: Client
  }, /*#__PURE__*/React.createElement(React.StrictMode, null, children)));
};
export default /*#__PURE__*/React.memo(ContextProvider);
//# sourceMappingURL=index.js.map